import type { PageIndicatorProps } from './PageIndicator';

export type OldPageIndicatorProps = Omit<PageIndicatorProps, 'page' | 'onChange'> & {
  /** @deprecated page를 대신 사용해주세요. */
  currentPage: number;
  /** @deprecated onChange를 대신 사용해주세요. */
  onChangePage?: PageIndicatorProps['onChange'];
};

export function convertOldPageIndicatorProps(props: OldPageIndicatorProps): PageIndicatorProps {
  const { currentPage, onChangePage, ...restProps } = props;

  return {
    ...restProps,
    page: currentPage,
    onChange: onChangePage,
  };
}
